var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"action",on:{"click":_vm.buttonClick}},[_vm._v(_vm._s(_vm.buttonCaption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }